import type { NavIconName } from './icons';

export interface NavItem {
  to: string;
  label: string;
  icon: NavIconName;
  /** Дополнительный корневой маршрут того же раздела, например календарь расписания. */
  aliases?: string[];
}

export const artistNav: NavItem[] = [
  { to: '/', label: 'Главная', icon: 'home' },
  { to: '/applications', label: 'Заявки', icon: 'requests' },
  { to: '/orders', label: 'Заказы', icon: 'orders' },
  { to: '/queue', label: 'Расписание', icon: 'schedule', aliases: ['/calendar'] },
  { to: '/profile', label: 'Профиль', icon: 'profile' },
];

export const customerNav: NavItem[] = [
  { to: '/my', label: 'Мои заказы', icon: 'orders' },
  { to: '/my/applications', label: 'Заявки', icon: 'requests' },
  { to: '/my/artists', label: 'Художники', icon: 'discover' },
  { to: '/my/settings', label: 'Уведомления', icon: 'notifications' },
];

/**
 * Корень раздела — любой пункт нижнего меню: с него стрелка «назад» не нужна,
 * а на вложенном экране она обязана быть.
 */
export function isRootLocation(location: string, nav: NavItem[]): boolean {
  return nav.some((item) => item.to === location || item.aliases?.includes(location));
}

/**
 * Точное совпадение для корня раздела, иначе «/my» подсвечивался бы вместе
 * с «/my/applications».
 */
export function isActive(location: string, to: string, nav: NavItem[]): boolean {
  const item = nav.find((candidate) => candidate.to === to);

  if (
    location === to ||
    item?.aliases?.some((alias) => location === alias || location.startsWith(`${alias}/`))
  ) {
    return true;
  }

  const deeper = nav.some((item) => item.to !== to && item.to.startsWith(`${to}/`));
  return !deeper && to !== '/' && location.startsWith(`${to}/`);
}
